import React from 'react';
import cn from 'classnames';
import Container from 'components/UI/Container';
import GallerySlider from '../GallerySlider';
import CustomTestimonials from '../CustomTestimonials';
import { ALL_GALLERIES_KEY } from '../../../constants';

import * as styles from './GalleryStyles.module.scss';

export default function AllGalleries({
  galleries,
  active,
  setActive,
  fadeInAnimation,
  testimonials,
}) {
  return (
    <div className={cn(styles.gallery, active !== ALL_GALLERIES_KEY && styles.hidden)}>
      <Container margin="None" className={styles.container}>
        <div className={cn(styles.wrapper, fadeInAnimation ? styles.fadeInAnimation : undefined)}>
          {galleries.slice(0, 3).map((gallery, i) => (
            <GallerySlider
              key={gallery.id}
              className={styles.slider}
              {...gallery}
              gallery={active}
              setActive={setActive}
              layout={(i + 1) % 2 === 0 ? 'mirrored' : 'default'}
            />
          ))}
        </div>
      </Container>
      <CustomTestimonials
        items={testimonials}
        className={fadeInAnimation ? styles.fadeInAnimation : undefined}
      />
      <Container className={styles.container}>
        <div className={cn(styles.wrapper, fadeInAnimation ? styles.fadeInAnimation : undefined)}>
          {galleries.slice(3).map((gallery, i) => (
            <GallerySlider
              key={gallery.id}
              className={styles.slider}
              {...gallery}
              gallery={active}
              setActive={setActive}
              layout={(i + 1) % 2 === 0 ? 'mirrored' : 'default'}
            />
          ))}
        </div>
      </Container>
    </div>
  );
}
